import React from "react"
import { useTranslation } from "react-i18next"

import Button from "@atoms/Button/Button"
import Heading from "@atoms/Heading/Heading"
import "@lang/i18n"
import i18nWrapper from "@lang/i18nWrapper"
import { isBrowser } from "@helpers/generic"

import Layout from "../components/layout.js"
import SEO from "../components/seo"

const NotFoundPage = () => {
  const { t } = useTranslation()

  if (!isBrowser()) {
    return false
  }

  return (
    <>
      <SEO
        title={t("Sorry, we couldn't find the page you were looking for.")}
        translations={[]}
      />
      <Layout
        translations={[]}
        currentLanguage="fi"
        lang="fi"
        customClass="max-w-full bg-not-found-image bg-cover bg-no-repeat"
      >
        <div className="max-w-screen-lg px-3 lg:mx-auto py-40 lg:py-80 text-center text-white">
          <Heading
            text={t("Sorry, we couldn't find the page you were looking for.")}
            level={1}
            customClasses="mb-5"
          />
          <Button variant="blueWhite" link="/">
            {t("Return to the home page")}
          </Button>
        </div>
      </Layout>
    </>
  )
}

export default i18nWrapper("NotFoundPage")(NotFoundPage)
